import * as React from 'react';
import ReactPlayer from 'react-player';

interface IProps{
    url: string;
    className?: string;
}

interface IState{
    playing: boolean;
}

export default class Player extends React.Component<IProps, IState>{

    constructor(props){
        super(props);

        this.state = {
            playing: false
        }
    }

    render(){
        return (<div className={`video-player ${this.props.className}`} onClick={() => this.setState({playing: !this.state.playing})}>
            <ReactPlayer 
                width='100%'
                height='100%'
                url={this.props.url} 
                controls={false}
                playing={this.state.playing}/>
        </div>)
    }
}


// WEBPACK FOOTER //
// ./src/core/ui/player.tsx